import * as React from 'react';
import { composer } from '../../../component-decorators/composer';
import s from './search-result-header.scss';
import { Box, Text, Heading } from 'wix-style-react';
export var SearchResultHeaderEmptyState = composer()
    .withTranslation()
    .compose(function (_a) {
    var query = _a.query, t = _a.t;
    return (React.createElement(Box, { direction: "vertical", align: "left", dataHook: 'search-result-header-empty-state' },
        React.createElement("div", { className: s.emptyStateTitle },
            React.createElement(Heading, { appearance: "H1", dataHook: "search-result-header-empty-state-title" }, t('searchResultHeaderEmptyState.noResult', { query: query }))),
        React.createElement(Text, { size: "medium", weight: "bold", dataHook: "search-result-header-empty-state-subtitle" }, t('searchResultHeaderEmptyState.tryAgain'))));
});
//# sourceMappingURL=search-result-header-empty-state.js.map